import { model as i18n } from '!/i18n'
import type { TvWithPrice } from '@/interfaces'
import {
  api,
  type CarouselItem,
  type CarouselItemTyped,
  type FeaturedCarouselTyped,
} from '@setplex/tria-api'
import { combine, type Store } from 'effector'
import {
  ssePurchasesModel,
  type AdjustPurchaseableFn,
} from '~/features/payment/sse-purchases'
import { extendMediaItemByLabelPriceTvChannel } from '~/shared/tools'

const formatFeaturedRowChannels = (
  items: CarouselItem[],
  adjust: AdjustPurchaseableFn
): CarouselItemTyped<TvWithPrice>[] => {
  return items.map((item: CarouselItem): CarouselItemTyped<TvWithPrice> => {
    return {
      ...item,
      channel:
        item.channel &&
        extendMediaItemByLabelPriceTvChannel(adjust(item.channel)),
    }
  })
}

export const $featuredCarouselTypeTv: Store<
  FeaturedCarouselTyped<TvWithPrice>[]
> = combine(
  api.banners.$featuredCarouselTypeTv,
  ssePurchasesModel.$channel,
  i18n.$t,
  (carousels, adjust) => {
    if (carousels?.length === 0) return []
    return carousels.map((carousel) => {
      return {
        ...carousel,
        content: formatFeaturedRowChannels(carousel.content, adjust),
      } as FeaturedCarouselTyped<TvWithPrice>
    })
  }
)

export const $featuredCarouselTvTitle: Store<string> = combine(
  i18n.$t,
  ({ t }) => t('channel_featured')
)
